import { getMarkerStyles } from 'app/core/markers/models';
import { strokeMarkerRenderer } from './painters';
const drawPolyline = (pCtx, item) => {
    pCtx.moveTo(item.x, item.y);
    item.points.forEach(point => {
        pCtx.lineTo(item.x + point.x, item.y + point.y);
    });
};
export const renderPolylineMarker = (marker, opts, ctx) => {
    const item = marker;
    const painter = (pCtx) => {
        pCtx.beginPath();
        if (item.closed) {
            drawPolyline(pCtx, item);
            pCtx.lineTo(item.x, item.y);
        }
        else {
            drawPolyline(pCtx, item);
        }
    };
    ctx.save();
    strokeMarkerRenderer(ctx, getMarkerStyles(marker), painter, opts);
    ctx.restore();
};
